import {
  GetUseOfForceReportForServiceProviderUnitResponse,
  Municipality,
  UseOfForceReportHeaderModel,
  UseOfForceReportModel,
  UseOfForceUploadedFile,
} from '../../api-service/clients';
import { moduleClientFactory } from '../../api-service/module-client-factory';

const useOfForceClient = moduleClientFactory.createServiceProviderUnitUseOfForceClient();
const caseClient = moduleClientFactory.createCitizenCaseClient();

export function getUseOfForceReport(serviceProviderUnitId: string): Promise<GetUseOfForceReportForServiceProviderUnitResponse> {
  return useOfForceClient.getUseOfForceReportForServiceProviderUnit({ serviceProviderUnitId });
}

export async function getMunicipalities(): Promise<Municipality[]> {
  const response = await caseClient.getMunicipalities();
  return response.municipalities ?? [];
}

export async function createUseOfForceReport(serviceProviderUnitId: string, header: UseOfForceReportHeaderModel, incidentIds: string[]): Promise<UseOfForceReportModel> {
  const response = await useOfForceClient.createUseOfForceReport({ serviceProviderUnitId, header, incidentIds });
  return response.report;
}

export async function updateUseOfForceReport(
  serviceProviderUnitId: string,
  reportId: string,
  header: UseOfForceReportHeaderModel,
  incidentIds: string[]
): Promise<UseOfForceReportModel> {
  const response = await useOfForceClient.updateUseOfForceReport({ serviceProviderUnitId, reportId, header, incidentIds });
  return response.report;
}

export async function registerUseOfForceReportSending(
  serviceProviderUnitId: string,
  reportId: string,
  sentToSupervisionAt: Date,
  operatorInformedAt: string | undefined
): Promise<UseOfForceReportModel> {
  const response = await useOfForceClient.registerUseOfForceReportSending({
    serviceProviderUnitId,
    reportId,
    sentToSupervisionAt,
    operatorInformedAt,
  });
  return response.report;
}

export async function deleteUseOfForceReportDraft(serviceProviderUnitId: string, reportId: string): Promise<void> {
  await useOfForceClient.deleteUseOfForceReportDraft({ serviceProviderUnitId, reportId });
}

export async function getUseOfForceReportPdf(serviceProviderUnitId: string, reportId: string): Promise<Blob> {
  const response = await useOfForceClient.getUseOfForceReportPdf({ serviceProviderUnitId, reportId });
  return response.data;
}

export async function attachUseOfForceReportActionPlan(
  serviceProviderUnitId: string,
  reportId: string,
  citizenId: string,
  file: UseOfForceUploadedFile
): Promise<UseOfForceReportModel> {
  const response = await useOfForceClient.attachUseOfForceReportActionPlan({ serviceProviderUnitId, reportId, citizenId, file });
  return response.report;
}

export async function removeUseOfForceReportActionPlan(serviceProviderUnitId: string, reportId: string, actionPlanId: string): Promise<UseOfForceReportModel> {
  const response = await useOfForceClient.removeUseOfForceReportActionPlan({ serviceProviderUnitId, reportId, actionPlanId });
  return response.report;
}

export async function getUseOfForceReportActionPlan(serviceProviderUnitId: string, reportId: string, actionPlanId: string): Promise<Blob> {
  const response = await useOfForceClient.getUseOfForceReportActionPlan({ serviceProviderUnitId, reportId, actionPlanId });
  return response.data;
}
